import { render, staticRenderFns } from "./AddressFrom.vue?vue&type=template&id=b9a63ba6&scoped=true&"
import script from "./AddressFrom.vue?vue&type=script&lang=js&"
export * from "./AddressFrom.vue?vue&type=script&lang=js&"
import style0 from "./AddressFrom.vue?vue&type=style&index=0&id=b9a63ba6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9a63ba6",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CheckoutAddressFormDrawer: require('/home/jeanmarcphilippe/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/components/Checkout/AddressFormDrawer.vue').default})
